<template>
  <div v-if="hint" class="hint">
    <p>{{ hint.text }} <span v-if="hint.examples">Na przykład:</span></p>
    <ul>
      <li v-for="example in hint.examples">{{ example }}</li>
    </ul>
  </div>
</template>

<style scoped>
.hint {
  margin: -8px var(--basic-margin);
}
</style>

<script>
import { getItem } from "@/reactive-cache";
import { REL_ELEM } from "@/structure";
export default {
  props: ["itemID"],
  computed: {
    item() {
      return getItem(this.itemID);
    },
    childCount() {
      return this.item.getChildren().length;
    },
    hint() {
      switch (true) {
        case this.itemID === "root:list":
          switch (this.childCount) {
            case 0:
              return {
                text: "List można używać do grupowania rzeczy wg tematu lub do zarządzania projektami.",
                examples: ["Ulubione filmy", "Praca magisterska", "Lista zakupów"],
              };
            case 1:
              return { text: "Możesz mieć dowolnie dużo list." };
            default:
              return null;
          }
        case this.itemID === "root:period" && this.childCount < 2:
          return {
            text: "Możesz stworzyć własne “okresy czasu” jeśli planowanie na konkretne daty jest zbyt mało elastyczne.",
            examples: ["Niedługo", "W wolnej chwili", "Może kiedyś"],
          };
        case this.itemID === "notepad":
          switch (this.childCount) {
            case 0:
              return {
                text: "Zapisz co chodzi Ci po głowie. Później możesz przenieść to do listy lub ustawić datę.",
              };
            case 1:
              return { text: "Możesz przypisać datę do rzeczy z notatnika." };
            default:
              return null;
          }
        case this.itemID === "null:" + REL_ELEM:
          return { text: "Rzeczy które nie są na żadnej liście pojawiają się tutaj." };
        case this.item.type === "list" && this.childCount === 1:
          return { text: "Zadania z list mogą mieć również ustawioną datę." };
        default:
          return null;
      }
    },
  },
};
</script>
